import type { FaireProductEntity } from "../../entity_types/product";

export const p_6kqkzp9v68: FaireProductEntity = {
  token: "p_6kqkzp9v68",
  type: "product",
  name: "OkLoveYouBye Little Stickies",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/676e7331fa3885e4742317ba9f5490720e2d3cfcb127f0019f8bf85b18f38eaa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2ae05ff05178de2ba088e4ff89e3a6b7886af23e31caafb83c76eb47b36f398d.jpeg",
    "https://cdn.faire.com/fastly/38ac23fc924e0d40445cc394a777be8125630e0d54708e08f7aa1c5f1e531e73.jpeg",
    "https://cdn.faire.com/fastly/fc90f0c655b146673defc5b938cceeb3109f14d8d151190d9ece14e4c7c66d7e.jpeg",
    "https://cdn.faire.com/fastly/648f57c83b649e20b9ff554cb9f7aaf7e409684db84c9e4f1f38c2659521a1f4.png",
    "https://cdn.faire.com/fastly/84453b364b7103a3d0082a3f7cc28a0efd41590dfa5aa9a1aa18de1067c39e3d.png",
  ],
  priceDollars: 5,
  description:
    "Because sometimes you need a little adhesive! Sweet watercolor illustrations bring joy to everyday tasks - perfect for your desk, home, bathroom mirrors, foreheads. The best part? They’re made in partnership with 3M, which means you get that classic Post-it® Notes stickiness that actually sticks!",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:24.906Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
